<template>
	<div class="offline-streams">
		<p>Список неработающих каналов ({{getOfflineStreams.length}})</p>
		<p class="link" @click="hidden" v-if="showLink">полный список
		</p>
		<div class="chanel">
			<div class="one">
				<p 	v-for="el in offlineCh[0]"
					:key="el">{{el}}</p>
			</div>
			<div class="two">
				<p 	v-for="el in offlineCh[1]"
					:key="el">{{el}}</p>
			</div>
			<div class="three">
				<p 	v-for="el in offlineCh[2]"
					:key="el">{{el}}</p>
			</div>
		</div>
		<total-offline-ch v-if="hiddenInfo" @hidden="hidden"/>
	</div>
</template>
<script>
	import { mapGetters, mapMutations } from "vuex";
	import TotalOfflineCh               from "./TotalOfflineCh";
	import { performRequest }           from "../script/ws/wsclient";

	export default {
		name      : "offlineStreams",
		components: { TotalOfflineCh },
		data() {
			return {
				offlineCh : [],
				hiddenInfo: false,
				showLink  : false,
				interval  : ''
			};
		},
		mounted() {
			// this.interval = setInterval(this.refresh, 10000)
		},
		beforeDestroy() {
			clearInterval(this.interval)
		},
		computed  : {
			...mapGetters(["getOfflineStreams", "getViewUser"])
		},
		methods   : {
			...mapMutations(["setStreams"]),
			hidden() {
				this.hiddenInfo = !this.hiddenInfo;
			},
			refresh() {
				let setStreams = this.setStreams;
				let command = {};
				command.section = "iptvlog";
				command.name = "getStreamStatus";
				performRequest(command, {operator: this.getViewUser}, a => {
					setStreams(a.data);
				});
			}
		},
		watch     : {
			"$store.state.streams"() {
				this.offlineCh = [];
				this.$store.state.offlineStreams.forEach(ch => {
					this.offlineCh.push(ch.display_name);
				});
				this.offlineCh = _.chunk(this.offlineCh, 3);
				this.offlineCh.length > 3
					? ( this.showLink = true )
					: ( this.showLink = false );
			}
		}
	};
</script>
<style scoped lang="scss">
	.offline-streams {
		width: 45rem;
		min-width: 41rem;
		padding: 0.5rem 1rem;
		margin: 0.5rem;
		background-color: rgba(184, 200, 209, 0.5);
		border-radius: 0.2rem;
		height: 8.5rem;
		box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.43);

		p {
			margin: 0.2rem;
			display: inline-block;
		}

		.link {
			margin-left: 2rem;
			font-size: 1.1rem;
			color: #1504dd;
			cursor: pointer;
			transition: all 0.3s;

			&:hover {
				color: #066700;
			}
		}

		.chanel {
			margin: 0 0.2rem;
			display: flex;
			justify-content: space-between;

			div {
				display: flex;
				flex-direction: column;
				justify-content: flex-start;

				p {
					margin: 0;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/OfflineStreams.vue